import { z } from 'zod';

/**
 * Global Zod error map that translates technical validation messages
 * into user-friendly language. This catches all schemas including
 * auto-generated ones from drizzle-zod / API contracts.
 *
 * Individual schemas with explicit `error` callbacks take precedence.
 */
z.setErrorMap((issue) => {
  switch (issue.code) {
    case 'invalid_type':
      if (issue.input === undefined || issue.input === null) {
        return { message: 'This field is required' };
      }
      return { message: `Expected ${issue.expected}` };

    case 'too_small': {
      const i = issue as typeof issue & { minimum: number; origin: string };
      if (i.origin === 'string') {
        if (i.minimum === 1) {
          return { message: 'This field is required' };
        }
        return { message: `Must be at least ${i.minimum} characters` };
      }
      return { message: `Must be at least ${i.minimum}` };
    }

    case 'too_big': {
      const i = issue as typeof issue & { maximum: number; origin: string };
      if (i.origin === 'string') {
        return { message: `Must be no more than ${i.maximum} characters` };
      }
      return { message: `Must be no more than ${i.maximum}` };
    }

    case 'invalid_format': {
      const i = issue as typeof issue & { format: string };
      if (i.format === 'email') {
        return { message: 'Please enter a valid email address' };
      }
      if (i.format === 'url' || i.format === 'uri') {
        return { message: 'Please enter a valid URL' };
      }
      if (i.format === 'uuid') {
        return { message: 'Invalid identifier' };
      }
      return { message: 'Invalid format' };
    }

    case 'invalid_value':
      return { message: 'Please select a valid option' };

    default:
      return { message: 'Invalid input' };
  }
});
